<template>
  <div class="font-14">
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">報告・承認</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label class="control-label">事業所</label>
                <select-office id="select-office" v-model="targetOfficeId" />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label class="control-label">予定日時</label>
                <div class="input-group">
                  <input id="start-day-from" class="form-control" type="date" v-model="startDayFrom">
                  <div style="line-height: 38px;">〜</div>
                  <input id="start-day-to" class="form-control" type="date" v-model="startDayTo">
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label class="control-label">利用者(前方一致)</label>
                <input type="text" class="form-control" v-model="userDisplayName" maxlength="64" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label class="control-label">スタッフ(前方一致)</label>
                <input type="text" class="form-control" v-model="staffDisplayName" maxlength="64" />
              </div>
            </div>
          </div>
          <div class="row form-actions">
            <div class="col-6" />
            <div class="col-1">
              <button type="submit" class="btn btn-success btn-circle" :disabled="isProcessing" @click="search">
                <i class="fa fa-search"></i>
              </button>
            </div>
            <div class="col-4">
              <button type="submit" class="btn btn-primary" :disabled="isProcessing" @click="downloadCsv">
                ダウンロードCSV
              </button>
            </div>
          </div>
        </div>
        <div class="row" v-if="page">
          <div class="col-12">
            <!-- Column -->
            <div class="card-body">
              <div class="dataTables_wrapper dt-bootstrap no-footer" v-if="page.data.length > 0">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="table-responsive">
                      <table id="report-table" class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th class="col-date">日時</th>
                            <th class="col-status">状態</th>
                            <th class="col-staff">利用者</th>
                            <th class="col-staff">スタッフ</th>
                            <th class="col-service-item">項目</th>
                            <th class="col-actions"></th>
                            <th class="col-pdf">ファイル</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="plan in page.data" :key="plan.id">
                            <tr>
                              <td class="col-date">
                                {{ dayString(plan.service.start_day, plan.service.start_day) }}<br>
                                {{ timeString(plan.service.start_hhmm, plan.service.end_hhmm) }}
                              </td>
                              <td class="col-status">
                                {{ constants.Code.PlanStatusList[plan.plan_status_cd] }}
                              </td>
                              <td class="col-user">
                                {{ plan.user.display_name }}
                              </td>
                              <td class="col-staff">
                                <template v-if="plan.reports.length > 0">
                                  {{ plan.reports[0].staff.display_name }}
                                </template>
                              </td>
                              <td class="col-service-item">
                                <template v-if="plan.reports.length > 0">
                                  <div>
                                    <template
                                      v-if="plan.service.service_type_id === 1180 || plan.service.service_type_id === 1182">
                                      <div class="mb-2">サービス：{{ plan.reports[0].service.service_type_input ?
                                        plan.reports[0].service.service_type_input :
                                        '(未入力)' }}
                                      </div>
                                    </template>
                                    <div>
                                      <span
                                        v-for="careItem in sortServiceItems(plan.service.service_type.care_item_sets, plan.reports[0].service.service_items)"
                                        :key="careItem.id">
                                        {{ careItem.short_name }}/
                                      </span>
                                    </div>
                                    <div v-if="plan.reports[0].service.destination">
                                      行き先： {{ plan.reports[0].service.destination }}
                                    </div>
                                    <div v-if="plan.reports[0].takeover_comment" class="p-t-10">
                                      申し送り： {{ plan.reports[0].takeover_comment }}
                                    </div>
                                  </div>
                                </template>
                              </td>
                              <td>
                                <template v-if="plan.reports.length > 0">
                                  <template v-if="plan.reports[0].approved_flag === 0">
                                    <button class="btn btn-secondary btn-rounded"
                                      @click="approved(plan, plan.reports[0], 1)" :disabled="isProcessing">承認
                                    </button>
                                    <button class="btn btn-primary btn-rounded" :disabled="isProcessing"
                                      @click="editReport(plan, plan.reports[0])">編集
                                    </button>
                                  </template>
                                  <template v-else>
                                    <button class="btn btn-danger btn-rounded"
                                      @click="approved(plan, plan.reports[0], 0)" :disabled="isProcessing">取消
                                    </button>
                                  </template>
                                </template>
                                <template v-else>
                                  <p class="alert alert-danger">
                                    削除されたデータ
                                  </p>
                                </template>
                              </td>
                              <td class="col-pdf">
                                <template v-if="plan.reports.length > 0">
                                  <div class="files-container">
                                    <div class="files">
                                      <a href="#" @click.prevent="openPdf(plan.reports[0])">
                                        <i class="pdf fa fa-file-pdf fa-2x"></i>
                                      </a>
                                    </div>
                                    <div class="files">
                                      <a :href="qrcodeUrl(plan.reports[0])" v-if="plan.reports[0].qrcode_id"
                                        target="_blank">
                                        <img :src="qrcodeUrl(plan.reports[0])" class="qr" />
                                      </a>
                                    </div>
                                  </div>
                                </template>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <pagination :page="page" v-if="page && page.data.length > 0" @change="changePage" />
              </div>
              <div v-else>
                <div class="alert alert-warning">
                  <p><i class="fa fa-info-circle p-r-10" />該当するデータが見つかりませんでした。</p>
                  <p>検索のヒント</p>
                  <ul>
                    <li>
                      検索条件を変更してみてください。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
    </div>
    <report-editor v-if="showReportEditModal" v-model="showReportEditModal" :plan="planToEdit" :report="reportToEdit"
      @update:modelValue="val => showReportEditModal = val" @close="onReportEditModalClosed"
      @cancel="onReportEditModalCancel" />
  </div>
</template>

<script setup>
import _ from 'underscore'
import dayjs from 'dayjs'
import api from '@/libs/Api'
import utils from '@/libs/Utils'
import SelectOffice from '@/components/SelectOffice.vue'
import Pagination from '@/components/Pagination.vue'
import Constants from '@/constants'
import ReportEditor from '@/components/ReportEditor.vue'
import 'dayjs/locale/ja'
import { ref, computed, onMounted } from 'vue'
import { useExecutor } from '@/libs/Executor'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'

dayjs.locale('ja')

const { exec } = useExecutor()
const router = useRouter()
const toast = useToast()

const userDisplayName = ref(null)
const targetOfficeId = ref(null)
const startDayFrom = ref(null)
const startDayTo = ref(null)
const page = ref(null)
const constants = ref(Constants)
const staffDisplayName = ref(null)
const isProcessing = ref(false)
const reportToEdit = ref(null)
const planToEdit = ref(null)
const showReportEditModal = ref(false)
const selectedPlanId = ref(null)
const selectedReportId = ref(null)

onMounted(() => {
  startDayFrom.value = dayjs().format('YYYY-MM-DD')
  startDayTo.value = dayjs().format('YYYY-MM-DD')
})

// eslint-disable-next-line no-unused-vars
const isApproved = computed(() => {
  return function (plan) {
    return plan.plan_status_cd === Constants.Code.PlanStatus.APPROVED
  }
})

const openPdf = (report) => {
  exec(async () => {
    isProcessing.value = true
    const res = await api.getReportPdfUrl(report.id)
    window.open(res.url, 'report_' + report.id)
    isProcessing.value = false
  })
    .catch(() => {
    })
}

const qrcodeUrl = (report) => {
  if (!report.qrcode) return ''
  return process.env.VUE_APP_FILE_URL + report.qrcode.filename
}

const changePage = async (pageParams) => {
  await search(pageParams)
}

const search = async (pageParams = 1) => {
  exec(async () => {
    const startDayFromParam = startDayFrom.value ? startDayFrom.value.replace(/-/g, '') : null
    const startDayToParam = startDayTo.value ? startDayTo.value.replace(/-/g, '') : null
    isProcessing.value = true
    const res = await api.getPlans({
      mode: Constants.QUERY_MODE_PAGING,
      page: pageParams,
      office_id: targetOfficeId.value || '',
      start_day_from: startDayFromParam,
      start_day_to: startDayToParam,
      user_display_name: userDisplayName.value || '',
      staff_display_name: staffDisplayName.value || null
    })

    if (res) {
      page.value = res
    }

    isProcessing.value = false

    return Promise.resolve()
  }).catch(() => {
  })
}

const formatHHMM = (hhmm) => {
  if (!hhmm) return '(未設定)'
  return hhmm.substr(0, 2) + ':' + hhmm.substr(2, 2)
}

// eslint-disable-next-line no-unused-vars
const formatDay = (day) => {
  return utils.formatDay(day)
}

// eslint-disable-next-line no-unused-vars
const formatDayOfWeek = (date) => {
  return dayjs(date).format('(ddd)')
}

const dayString = (day, date) => {
  return utils.formatDay(day) + ' ' + dayjs(date).format('(ddd)')
}

const timeString = (startHhmm, endHhmm) => {
  return formatHHMM(startHhmm) + ' - ' + formatHHMM(endHhmm)
}

const sortServiceItems = (careItemSets, serviceItems) => {
  let result = []
  careItemSets.forEach(careItemSet => {
    careItemSet.care_item_groups.forEach(careItemGroup => {
      careItemGroup.care_items.forEach(careItem => {
        if (_.find(serviceItems, serviceItem => careItem.id === serviceItem.care_item_id)) {
          result.push(careItem)
        }
      })
    })
  })
  return result
}

// eslint-disable-next-line no-unused-vars
const diffServiceItems = (planServiceItems, reportServiceItems) => {
  let hasDiff = false

  planServiceItems.forEach(planServiceItem => {
    if (!_.find(reportServiceItems, reportServiceItem => reportServiceItem.care_item_id === planServiceItem.care_item_id)) {
      hasDiff = true
    }
  })
  reportServiceItems.forEach(reportServiceItem => {
    if (!_.find(planServiceItems, planServiceItem => planServiceItem.care_item_id === reportServiceItem.care_item_id)) {
      hasDiff = true
    }
  })

  return hasDiff
}

const downloadCsv = async () => {
  exec(async () => {
    const startDayFromParam = dayjs(startDayFrom.value).format('YYYYMMDD')
    const startDayToParam = dayjs(startDayTo.value).format('YYYYMMDD')
    const userDisplayNameParam = userDisplayName.value || null
    const staffDisplayNameParam = staffDisplayName.value || null

    isProcessing.value = true

    const res = await api.exportPlans({
      office_id: targetOfficeId.value || '',
      start_day_from: startDayFromParam,
      start_day_to: startDayToParam,
      user_display_name: userDisplayNameParam,
      staff_display_name: staffDisplayNameParam
    })

    if (res) {
      saveCsvFile(res.data, 'report')
    }

    isProcessing.value = false

    return Promise.resolve()
  }).catch(() => {
  })
}

const saveCsvFile = (res, filename) => {
  // CSVデータ取得 - BOM 付与
  const blob = new Blob([res], { type: 'text/csv' })

  filename += '_' + dayjs(Date.now()).format('YYYYMMDD_HHmmss') + '.csv'

  if (window.navigator.msSaveBlob) {
    // IE11 ( msSaveBlog が有効なら)
    window.navigator.msSaveBlob(blob, filename)
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    link.click()
    window.URL.revokeObjectURL(url)
  }
}

// eslint-disable-next-line no-unused-vars
const editPlan = (plan) => {
  router.push(`/plan/${plan.id}`)
}

const editReport = (plan, report) => {
  selectedPlanId.value = null
  selectedReportId.value = report.id
  reportToEdit.value = report
  planToEdit.value = plan
  showReportEditModal.value = true
}

// eslint-disable-next-line no-unused-vars
const addReport = (plan) => {
  selectedPlanId.value = plan.id
  selectedReportId.value = null
  planToEdit.value = plan
  reportToEdit.value = null
  showReportEditModal.value = true
}

const approved = async (plan, report, approved = true) => {
  selectedPlanId.value = null
  selectedReportId.value = report.id

  exec(async () => {
    isProcessing.value = true
    const res = await api.updateReport({
      id: report.id,
      approved_flag: approved
    })
    report.approved_flag = approved
    plan.plan_status_cd = res.plan.plan_status_cd
    if (report.approved_flag) {
      toast.success('認しました。')
    } else {
      toast.error('取り消しました。')
    }

    isProcessing.value = false
    return Promise.resolve()
  })
    .catch(() => {
    })
}

</script>

<style lang="scss" scoped>
#report-table {
  width: 1200px;
}

td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col-office {
  width: 130px;
  max-width: 130px;
}

.col-date {
  width: 120px;
  max-width: 120px;
}

.col-hhmm {
  width: 140px;
  max-width: 140px;
}

.col-status {
  width: 100px;
  max-width: 100px;
  text-align: center;
}

.col-user {
  width: 130px;
  max-width: 130px;
}

.col-staff {
  width: 130px;
  max-width: 130px;
}

.col-service-type {
  text-align: center;
}

.col-service-code {
  width: 170px;
  max-width: 170px;
  text-align: center;
}

.col-service-item {
  width: 250px;
  max-width: 250px;
  white-space: normal;
}

.col-actions {
  width: 170px;
  max-width: 170px;
}

.col-pdf {
  width: 90px;
  max-width: 90px;
}

.has-diff {
  color: red;
}

.pdf {
  color: black;
  padding-top: 2px;
  padding-right: 2px;
}

.qr {
  width: 30px;
  height: 30px;
}

.files {
  float: left;
}
</style>
